import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';

import * as billboardActions from '../actions/index';
import * as userActions from '../../global/user/actions/index';

import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import logger from '../../global/logger';

class BillboardIndex extends Component {

    componentDidMount() {
        this.props.onFetchPlaylists(() => {
            if (this.props.playlists.length > 0) {
                logger.log("selecting playlist: " + JSON.stringify(this.props.playlists[0]));
                this.props.onSelectPlaylist(this.props.playlists[0]);
            }
        });
    }

    render () {
        
        const { path } = this.props.match;

        let content = (
            <div className="text-center">
                <p className="text-gray-500 text-xl align-middle">Select a playlist from the list to edit.</p>
            </div>
        );

        if (this.props.loading_playlists) {
            content = (
                <LoadingIndicator />
            )
        }

        return content;
    }
}

const mapStateToProps = state => {
    return {
        loading_playlists: state.billboard.loading_playlists,
        playlists: state.billboard.playlists,
        selected_playlist: state.billboard.selected_playlist,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchPlaylists: (callback) => dispatch(billboardActions.fetchPlaylists(callback)),
        onSelectPlaylist: (playlist) => dispatch(billboardActions.selectPlaylist(playlist)),
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillboardIndex));